import { join } from 'path';

import { fetchGet } from '#providers/Fetch';
import makeHandler from '#services/makeHandler';

const URL = {
  fetch: id => join('order/service', id),
};

const fetch = makeHandler(async (id, params) => fetchGet(
  URL.fetch(id), { params }
), { defaultError: 'Error fetching service' });

export default {
  fetch,
};
